import api from "./api";

class VersioniSottoProgettiManager {

    versione(versione_id: number | string, config?: any) {
        return api.get(`/versioni/${versione_id}`, config)
    }

    riprendiVersione(versione_id: number | string){
        return api.post(`/versioni/${versione_id}/riprendi`)
    }
}

const versioniSottoProgettiManager = new VersioniSottoProgettiManager()

export default versioniSottoProgettiManager
